import { render, staticRenderFns } from "./SearchWidget.vue?vue&type=template&id=21a7b578"
import script from "./SearchWidget.vue?vue&type=script&lang=js"
export * from "./SearchWidget.vue?vue&type=script&lang=js"
import style0 from "./SearchWidget.vue?vue&type=style&index=0&id=21a7b578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports